/* eslint-disable no-debugger */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

//  http://localhost:3000/api/
//  https://alimeraapiwebdev.azurewebsites.net/api/
//  https://alimeraapiwebprod.azurewebsites.net/api/

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseUrl: process.env.VUE_APP_BASE_URL,
    token: "",
    patientId: -1,//????
    userId: -1,
    siteCode: "-1",
    isAuthenticated: false,
    menuOptions: [],
    roleId: -1,
    username: "",
    viewedVideo: false,
    selectedAssessmentType: {},
    roles: [
      { id: 3, name: "Site Admin" },
      { id: 2, name: "Super Admin" },
      { id: 1, name: "Patient" },
    ],
    menuDisabled: false,
    needToChangePassword: false
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload
      var now = new Date();
      var time = now.getTime();
      var expireTime = time + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = 'token=' + state.token + ';expires=' + now.toGMTString() + ';path=/';
      axios.defaults.headers.common = { authorization: "bearer " + payload };

      if (payload == '') {
        state.menuOptions = []
        state.isAuthenticated = false
        state.roleId = -1
        state.siteCode = -1
        state.patientId = -1
        state.userId = -1
        document.cookie = 'token=;expires=' + now.toGMTString() + ';path=/';

      } else {
        if (state.roleId == 2 || state.roleId == 3) {
          state.menuOptions = [
            { title: "Home", icon: "dashboard", url: "/" },
            { title: "User", icon: "people", url: "/user" },
            { title: "Patient", icon: "medical_services", url: "/patient" },
            { title: "Assessment", icon: "assignment", url: "/assessmentType" },
            { title: "Global Assessment Report", icon: "insert_chart", url: "/assessmentReport" },
            { title: "Change My Password", icon: "fingerprint", url: "/changeMyPassword" },
          ]
          if (state.roleId == 2) {
            state.menuOptions.push({ title: "Audit Trailing", icon: "chrome_reader_mode", url: "/audit" })
          }
        }
        else if (state.roleId == 1) {
          state.menuOptions = [
            { title: "Home", icon: "dashboard", url: "/" },
            { title: "Change My Password", icon: "insert_chart", url: "/changeMyPassword" }
          ]
        }
        state.isAuthenticated = true
      }
      // route to homepage
      // window.location.replace("/")
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload
    }, setPatientId(state, payload) {
      state.patientId = payload
    }, setMenuOptions(state, payload) {
      state.menuOptions = payload
    },
    setMenuAsDisabled(state) {
      state.menuDisabled = true;
    },
    setMenuAsEnabled(state) {
      state.menuDisabled = false;
    },
    setNeedToChangePassword(state, payload) {
      state.needToChangePassword = payload;
    }
    // , setUserId(state, userId) {
    //   state.userId = userId
    // }
    , setSelectedAssessmentType(state, model) {
      state.selectedAssessmentType = model
    }
    , setLoggedUser(state, payload) {
      //debugger;
      state.siteCode = payload.siteCode
      state.roleId = payload.roleId
      state.userId = payload.userId
      state.username = payload.username
    }, setViewedVideo(state, payload) {
      state.viewedVideo = payload;
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getIsAuthenticated: state => state.isAuthenticated,
    getUserMenuOptions(state) {
      return state.menuOptions
    },
    getBaseUrl: state => state.baseUrl,
    getPatientId: state => state.patientId,
    getUserId: state => state.userId,
    getUsername: state => state.username,
    getRoles: state => state.roles,
    getRoleId: state => state.roleId,
    getSiteCode: state => state.siteCode,
    getSelectedAssessmentType: state => state.selectedAssessmentType,
    getViewedVideo: state => state.viewedVideo,
    getIsMenuDisabled: state => state.menuDisabled,
    getNeedToChangePassword: state => state.needToChangePassword,
  }
})
